import { create } from "zustand";

export interface OPACState {
  libraryID: string | number | null;
  setLibraryID: (libraryID: string | number | null) => void;
}

const useOPACStore = create<OPACState>((set) => ({
  libraryID: null,
  setLibraryID: (libraryID: string | number | null) =>
    set(() => ({ libraryID: libraryID })),
}));
export default useOPACStore;

